<template>
  <v-app style="background-color: #546E7A;">
    <div>
      <v-toolbar style="background-color: #455A64; color: white">
        <v-toolbar-title>BROKEN IMMORTALS</v-toolbar-title>
        <v-spacer />
        <v-toolbar-items class="d-none d-md-block">
          <template v-for="myRoute in routerData.options.routes">
            <v-btn
              v-if="myRoute.button"
              :to="myRoute.path"
              elevation="2"
              color="#546E7A"
              class="white--text"
              :key="myRoute.name">
              {{ myRoute.name }}
            </v-btn>
          </template>
          <v-btn
            v-if="$store.state.admin"
            to="/Users"
            elevation="2"
            color="#546E7A"
            class="white--text">
            User Management
          </v-btn>
          <v-btn
            v-if="$store.state.username === ''"
            @click="signIn()"
            elevation="2"
            color="#546E7A"
            class="white--text">Sign In</v-btn>
          <v-menu v-else v-model="hoverSign" open-on-hover bottom offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                elevation="2"
                color="#546E7A"
                class="white--text">
                  {{ $store.state.username }}
              </v-btn>
            </template>
            <v-list color="#546E7A">
              <v-list-item @click="signOut()">
                <v-list-item-title class="white--text">
                  Sign Out
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar-items>
        <div class="d-md-none">
          <v-menu bottom left>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" color="#546E7A" class="white--text">
                MENU
              </v-btn>
            </template>
            <v-list color="#546E7A">
              <template v-for="myRoute in routerData.options.routes">
                <v-list-item
                  v-if="myRoute.button"
                  :key="myRoute.name"
                  :to="myRoute.path">
                  <v-list-item-title class="white--text">
                    {{ myRoute.name }}
                  </v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                v-if="$store.state.username === ''"
                @click="signIn()">
                <v-list-item-title class="white--text">
                  SIGN IN
                </v-list-item-title>
              </v-list-item>
              <template v-else>
                <v-list-item @click="signOut()">
                  <v-list-item-title class="white--text">
                    SIGN OUT
                  </v-list-item-title>
                </v-list-item>                 
              </template>
            </v-list>
          </v-menu>
        </div>
      </v-toolbar>
      <v-content>
        <router-view />
      </v-content>
    </div>
  </v-app>
</template>
<script>
import routeData from './router.js';
import firebase from 'firebase/app';

export default {
  name: 'App',
  data() {
    return {
      routerData: null,
      hoverSign: false
    };
  },
  mounted() {
    if (localStorage.contentTagging) {
      this.$store.state.contentTagging = (localStorage.contentTagging === 'true');
    }
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        const validateUser = {
          uid: user.uid,
          name: user.displayName,
          email: user.email
        };
        this.$store.dispatch('validateAccount', validateUser);
      }
    });
    this.routerData = routeData;
  },
  computed: {},
  methods: {
    signIn() {
      firebase
        .auth()
        .signInWithPopup(new firebase.auth.GoogleAuthProvider())
        .catch((error) => {
          console.log(error);
        });
    },
    signOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$store.dispatch('userLogout');
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
};
</script>
